<template>
  <div class="subpage main_area s11ss" style="position: relative">
    <div class="">
      <div data-v-77dd5443="" class="detail_area">
        <div data-v-77dd5443="" class="layout intl_wallet_layout record_wallet_details">
          <div data-v-77dd5443="" class="mypromo_filter_block"><input data-v-77dd5443="" type="hidden" id="date_check" /></div>
          <div data-v-77dd5443="" data-v-5c998777="" class="deposit_header tableheader_bg">
            <div data-v-77dd5443="" data-v-5c998777="">已领取次数{{ userredpacket.acquirednum }}</div>
            <div data-v-77dd5443="" data-v-5c998777="" class="d-flex align-items-center">
              <span data-v-77dd5443="" data-v-5c998777="" id="wallet_bal" class="wallet_balance mr-2 main_wallet_bal" style="font-size: 14px; font-weight: 400">剩余领取次数{{ userredpacket.sendnums }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div @click="getwelfare" style="width:40%" data-v-77dd5443="" class="sub_list_tab wallet_history_tab"> -->
      <div @click="$parent.goNav('/hongbao')" style="width:40%" data-v-77dd5443="" class="sub_list_tab wallet_history_tab">
        <a data-v-77dd5443="" class="block_content active">抢领红包</a> 
   
      </div>
      <div class="detail_area">
        <div class="layout position-relative">
          <ul class="announce_list" id="zhanneixin" style="" v-if="redpacketList.length > 0">
            <li v-for="(item, index) in redpacketList" :key="index">
              <div class="collapse">
                <div class="block_content"></div>
                <div class="block_content">
                  <div class="title">充值金额：{{ item.money }}</div>
                </div>
                <div class="block_content">
                  <div class="type">充值时间： {{ item.created_at }}</div>
                </div>
              </div>
              <div class="collapse">
                <div class="block_content"></div>
                <div class="block_content">
                  <div class="title">红包金额：{{ item.redpacketmoney }}</div>
                </div>
                <div class="block_content">
                  <div class="type">充值时间： {{ item.created_at }}</div>
                </div>
              </div>
            </li>
          </ul>
          <div data-v-77dd5443="" v-else class="no_data">
            <img data-v-77dd5443="" alt="" src="/static/image/img_emptybox.png" width="30%" />
            <div data-v-77dd5443="">暂无记录</div>
          </div>
          <el-pagination v-if="redpacketShowData.total" style="margin: 20px 0 0px 120px; background: none" @current-change="getredpacket" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="redpacketShowData.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    that.getredpacket();
    that.getuserredpacket();
  },
  methods: {
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, '您的剩余次数不足！');

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);

          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getredpacket();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, '服务器异常，请稍后再试');
          that.$parent.hideLoading();
        });
    },
    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    // 获取红包记录
    getredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.post('/api/redpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.redpacketList = res.data.data;
          that.redpacketShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/welfare.vue